<template>
<div class="chapter">
<div class="inner_page">
<p class="C191"><a id="page_vi">Acknowledgments</a></p><a id="page_vi">
<p class="C198">To Theresa May, my thanks for instigating this project, and to Casey Kittrell, my gratitude for shepherding it to life. For their early reading of the sonnets, I am grateful to Cola Franzen and David Anderson. For their care, expertise, and unfailing good humor in the preparation of the manuscript, I thank Veronica Jorgensen and Rachel Kelleher.</p>
<p class="C199">MARGUERITE FEITLOWITZ</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_Acknowle.vue?5f995a22